import React from 'react'
import styles from './styles.module.scss'

const FitOptionWrapper = ({ children }: { children: React.ReactNode }) => {
  return <div className={styles.fitOptionsWrapper}>{children}</div>
}

export default FitOptionWrapper
